// Förval för tröskelreglerna — utgångspunkter, inte facit.
//
// Delas av tröskel-labbet och fliken Avancerat så att siffrorna bara finns på ett
// ställe. Namnen anger kravet (max tillåten temperatur), inte vad enheten råkar
// hålla för stunden.

import { ThresholdSettings } from '../services/advancedRulesApi';

export const DEFAULT_THRESHOLD_SETTINGS: ThresholdSettings = {
    excursionOn: true,
    armLevel: -15,
    recoverLevel: -17,
    ceilingLevel: -5,
    deadlineMin: 240,
    extendWhileFalling: false,

    budgetOn: true,
    safeLimit: -12,
    budgetMinutes: 240,
};

export interface ThresholdPreset {
    name: string;
    settings: ThresholdSettings;
}

export const THRESHOLD_PRESETS: ThresholdPreset[] = [
    {
        name: 'Frys (max −18)',
        settings: { ...DEFAULT_THRESHOLD_SETTINGS },
    },
    {
        name: 'Kyl (max +8)',
        settings: {
            excursionOn: true,
            armLevel: 8,
            recoverLevel: 6,
            ceilingLevel: 15,
            deadlineMin: 240,
            extendWhileFalling: false,

            budgetOn: true,
            safeLimit: 8,
            budgetMinutes: 240,
        },
    },
];
